import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";
import DateAdapter from "./adapters/DateAdapter";

export default class CustomerDeliverySiteOnboardingsResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: [
                {
                    id: '1',
                    requester: 'requester@sapore.com',
                    request_timestamp: '2025-01-01T10:00:00Z',
                    state: 'PENDING',
                    customer: {
                        code: '001',
                        fantasy_name: 'Cliente',
                        business_name: 'Cliente SA',
                        taxpayer_identification_number: '30700111223'
                    },
                    request: {
                        id: '2',
                        name: 'Site Name',
                        location: {
                            address: 'Address 123',
                            city: 'CABA',
                            postal_code: '1425',
                            latitude: null,
                            longitude: null,
                        },
                        jurisdiction: 'Capital Federal',
                        zone: 'CABA',
                        preferred_delivery_time_range: 'de 8 a 12',
                        exceptional_frequency: ['LUNES']
                    },
                    authorizations: {
                        tax_authorization: null,
                        logistics_authorization: null,
                    }
                }
            ],
            errors: []
        };
    }

    deliverySiteOnboardings() {
        return this.content().map(rawDeliverySiteOnboarding => ({
            id: rawDeliverySiteOnboarding.id,
            requester: rawDeliverySiteOnboarding.requester,
            requestTimestamp: this._adaptDatetime(rawDeliverySiteOnboarding.request_timestamp),
            state: this._adaptState(rawDeliverySiteOnboarding.state),
            customer: this._customerFrom(rawDeliverySiteOnboarding.customer),
            request: this._requestFrom(rawDeliverySiteOnboarding.request),
            taxAuthorization: rawDeliverySiteOnboarding.authorizations.tax_authorization ,
            logisticsAuthorization: rawDeliverySiteOnboarding.authorizations.logistics_authorization ,
        }));
    }

    _adaptDatetime(datetime) {
        if (datetime === null) {
            return "-";
        }
        return DateAdapter.adaptDatetime(datetime);
    }

    _adaptState(value) {
        if (value === "PENDING") {
            return "Pendiente";
        }
        if (value === "PROCESSING_BY_AREA_STATE") {
            return "Proceso de Area";
        }
        if (value === "CLOSED") {
            return "Cerrado";
        }
        return value;
    }

    _customerFrom(rawCustomer) {
        return {
            code: rawCustomer.code,
            fantasyName: rawCustomer.fantasy_name,
            businessName: rawCustomer.business_name,
            taxpayerIdentificationNumber: rawCustomer.taxpayer_identification_number
        };
    }

    _requestFrom(rawRequest) {
        return {
            id: rawRequest.id,
            name: rawRequest.name,
            address: rawRequest.location.address,
            city: rawRequest.location.city,
            postalCode: rawRequest.location.postal_code,
            jurisdiction: rawRequest.jurisdiction,
            zone: rawRequest.zone,
            preferredDeliveryTimeRange: rawRequest.preferred_delivery_time_range,
            exceptionalFrequency: rawRequest.exceptional_frequency || [],
        };
    }
}
